import ServicePageTemplate from "@/components/layout/ServicePageTemplate";

export default function PlumbingPage() {
  return (
    <div data-testid="plumbing-page">
      <ServicePageTemplate
        overline="Plumbing"
        title="Reliable plumbing — built to last, finished clean."
        sub="From small repairs to complete plumbing system installations, our team delivers honest recommendations and clean workmanship."
        image="https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg"
        serviceTitle="Plumbing"
        services={[
          "Pipe Repair & Replacement",
          "Leak Detection",
          "Drain Cleaning & Unclogging",
          "Water Heater Installation",
          "Tankless Water Heater Services",
          "Toilet & Faucet Installation",
          "Sewer & Drain Repairs",
          "Maintenance & Inspections",
          "Emergency Plumbing Repairs",
        ]}
        benefits={[
          "Long-Lasting Repairs",
          "Honest Recommendations",
          "Clean Workmanship",
          "Quality Materials",
          "Responsive Scheduling",
          "Professional Service",
        ]}
        faq={[
          { q: "Do you handle emergency plumbing?", a: "Yes — call 818-606-3769 and we'll dispatch a technician as quickly as possible." },
          { q: "Tankless or tank water heaters?", a: "We install both and can advise based on your hot water demand, fuel type and budget." },
          { q: "Do you offer leak detection?", a: "Yes. We use modern detection methods to find slab and concealed leaks with minimal invasiveness." },
        ]}
      />
    </div>
  );
}
